module.exports = __webpack_public_path__ + "static/img/clientConceptPic4.8d0c8ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/clientConceptPic4.jpg
// module id = e7vr
// module chunks = 0